<template>
  <div class="usage-terms-table">
    <v-data-table
      class="sms-credits-list"
      :headers="headers"
      :items="list"
      :loading="loading"
      :hide-actions="true"
      :no-data-text="$t('message.termsOfUse.message.noTermRegistered')"
      no-results-text=""
    >
      <template slot="items" slot-scope="props">
        <usage-terms-table-item
          :item="props.item"
          :is-vivo-provider="isVivoProvider"
          @copied="reload"
          @removed="reload"
          @statusChanged="reload"
        />
      </template>
    </v-data-table>

    <infinite-loading :identifier="loadingId" @infinite="load">
      <div class="infinite-text" slot="no-results"></div>
      <div class="infinite-text" slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import UsageTermsTableItem from "@views/usage-terms/components/UsageTermsTableItem.vue";
import InfiniteLoading from "vue-infinite-loading";
import provider from "@mixins/provider";

export default {
  components: {
    InfiniteLoading,
    UsageTermsTableItem,
  },

  data() {
    return {
      loading: false,
      page: 0,
      loadingId: +new Date(),
      list: [],
    };
  },

  mixins: [provider],

  computed: {
    isAdmin() {
      return this.$store.state.users.admin && !this.$store.state.users.user;
    },
    user() {
      return this.$store.state.users.user;
    },
    headers() {
      return this.isVivoProvider
        ? [
            {
              text: this.$t("message.admGenerics.message.active"),
              value: "creationDate",
              sortable: false,
              width: 50,
            },
            {
              text: this.$t("message.generics.message.status"),
              value: "amount",
              sortable: false,
            },
            {
              text: this.$t("message.generics.message.name"),
              value: "expirationDate",
              sortable: false,
            },
            {
              text: this.$t("message.termsOfUse.message.lastChange"),
              value: "",
              sortable: false,
            },
            {
              text: this.$t("message.termsOfUse.message.publicationDate"),
              value: "",
              sortable: false,
            },
            {
              text: this.$t("message.admGenerics.message.edition"),
              value: "",
              sortable: false,
            },
          ]
        : [
            { text: "", value: "", sortable: false, width: 50 },
            {
              text: this.$t("message.admGenerics.message.active"),
              value: "creationDate",
              sortable: false,
              width: 50,
            },
            {
              text: this.$t("message.generics.message.status"),
              value: "amount",
              sortable: false,
            },
            {
              text: this.$t("message.generics.message.name"),
              value: "expirationDate",
              sortable: false,
            },
            {
              text: this.$t("message.termsOfUse.message.lastChange"),
              value: "",
              sortable: false,
            },
            {
              text: this.$t("message.termsOfUse.message.publicationDate"),
              value: "",
              sortable: false,
            },
            {
              text: this.$t("message.admGenerics.message.edition"),
              value: "",
              sortable: false,
            },
          ];
    },
  },

  methods: {
    async load($state) {
      try {
        this.loading = true;

        const userId = this.isAdmin ? 0 : this.user.id;

        const termsList = await this.$api.usageTerms.list({
          page: this.page,
          userId,
        });

        this.page++;

        this.list.push(...termsList);

        if (termsList.length) {
          if ($state) {
            $state.loaded();
          }
        } else {
          if ($state) {
            $state.complete();
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    reload() {
      this.list = [];
      this.page = 0;
      this.loadingId++;
    },
  },

  mounted() {},

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped></style>
